import { Query } from 'firebase/firestore';
import { ConverterFactory } from '../../../functions/src/util/firestore/ConverterFactory';
import { EventDocument } from '../../contexts/organizer/create-event/CreateEventContext';
import { EventCreationSettings } from 'src/contexts/organizer/create-event/constants';

export const queryEventsClient = async <TEvent extends EventDocument>(
  gameIds: string[] | 'ALL',
  startDate: Date,
  endDate: Date,
  collectionName: EventCreationSettings['eventType'],
  queryModifier?: (query: Query) => Query[],
) => {
  const events: TEvent[] = [];

  const fetchEventsForGameId = async (gameId: string) => {
    const {
      collectionGroup,
      collection,
      where,
      query: createQuery,
      getDocs,
    } = await import('firebase/firestore');
    const { firestore } = await import(
      '../../config/firebase-client/firestore'
    );
    const ref =
      gameId === 'ALL'
        ? collectionGroup(firestore, collectionName)
        : collection(firestore, `Game/${gameId}/${collectionName}`);

    const queryBase = createQuery(
      ref,
      where('date', '>=', startDate),
      where('date', '<=', endDate),
    );

    const finalQueries = queryModifier ? queryModifier(queryBase) : [queryBase];

    const events = await Promise.all(
      finalQueries.map(async (finalQuery) => {
        const snap = await getDocs(
          finalQuery.withConverter(
            ConverterFactory.buildDateConverter<TEvent>(),
          ),
        );
        return snap.docs.map((doc) => {
          const eventData = doc.data();
          return {
            ...eventData,
          };
        });
      }),
    );
    console.log({ events });
    return events.flat();
  };

  if (Array.isArray(gameIds)) {
    for (const gameId of gameIds) {
      const gameEvents = await fetchEventsForGameId(gameId);
      events.push(...gameEvents);
    }
  } else {
    const gameTournaments = await fetchEventsForGameId(gameIds);
    events.push(...gameTournaments);
  }

  return events;
};
